import { useMemo } from 'react'
import Popup from 'reactjs-popup'
import awardIcon from '../../../../../assets/images/award.png'
import exclamationMark from '../../../../../assets/images/warning-image.png'
import UniversitiesStepper from './UniversitiesStepper'
import Button from '../../../../Button'
import Modal from 'components/Modal'

const ModalAfterSubmit = ({
  modalAfterSubmitOpened,
  handleCloseModalAfterSubmit,
  isGenerated,
  answer,
  subjectResult,
  numberOfCorrectAnswers,
  subjectLength,
}) => {
  const congrats = useMemo(() => {
    if (answer) {
      return Object.values(answer?.averages ?? {})?.some(
        value => value <= subjectResult,
      )
    }
    return []
  }, [answer, subjectResult])
  const percentValueAsNumber = Number(answer?.solvingPercent?.slice(0, -1))
  const isFullySolved = numberOfCorrectAnswers === subjectLength
  return (
    <Modal
      isOpen={modalAfterSubmitOpened}
      closeModal={handleCloseModalAfterSubmit}
    >
      <div className="modal">
        <img
          className="fade"
          alt="hintImage"
          src={
            isGenerated || answer?.averages === null
              ? percentValueAsNumber <= 50 && numberOfCorrectAnswers !== 0
                ? awardIcon
                : exclamationMark
              : congrats
                ? awardIcon
                : exclamationMark
          }
          width={congrats ? 200 : 250}
          height={congrats ? 200 : 250}
        />
        <div className="flex items-center justify-center text-over-ternary-background">
          <div className="flex flex-col">
            <div className="text-2xl font-bold">
              {isGenerated || answer?.averages === null
                ? percentValueAsNumber <= 50 && numberOfCorrectAnswers !== 0
                  ? 'Felicitări'
                  : 'Mai pregătește-te'
                : congrats
                  ? 'Felicitări !'
                  : 'Mai pregătește-te'}
            </div>
            <h2 className="text-lg font-bold ">
              Ai obținut nota{' '}
              <span className="text-[#00D9B2FF]">
                {subjectResult.toFixed(2)}
              </span>
            </h2>
            {!isGenerated && answer?.averages ? (
              <UniversitiesStepper
                result={subjectResult.toFixed(2)}
                universities={answer?.averages}
              />
            ) : null}

            <div className="flex justify-center items-center flex-col text-over-ternary-background">
              <div className="flex flex-col gap-[10px]  !font-normal text-left">
                <div className="rounded flex justify-center items-center text-center p-[4px]">
                  <h4 className="font-bold">
                    {isFullySolved
                      ? 'Felicitări! Ai rezolvat simularea integral!'
                      : numberOfCorrectAnswers === 0
                        ? 'Încearcă mai mult data viitoare!'
                        : 'Ai fost in primii'}{' '}
                    {!isFullySolved && numberOfCorrectAnswers > 0 ? (
                      <>
                        <span className="text-[#00D9B2FF]">
                          {answer?.solvingPercent}
                        </span>{' '}
                      </>
                    ) : null}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Button
          className="bg-primary w-20 h-10 mt-5"
          onClick={handleCloseModalAfterSubmit}
        >
          Închide
        </Button>
      </div>
    </Modal>
  )
}

export default ModalAfterSubmit
